import { render, staticRenderFns } from "./MasivePrint.vue?vue&type=template&id=97671192"
import script from "./MasivePrint.vue?vue&type=script&lang=js"
export * from "./MasivePrint.vue?vue&type=script&lang=js"
import style0 from "./MasivePrint.vue?vue&type=style&index=0&id=97671192&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports